import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';


const SelfLearningResources = () =>{
  
  return (
    <div className="SelfLearningResources">
      <section className="inner-banner banner-align">
      <img className="img-fluid" src="./assets/img/innerbanner/self-learning-banner-image.jpg" alt=""/>
    </section>
    <section  className="research-box-area">
         <Container>
         <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/ResearchSupport">
                  Research Support
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Self-Learning Resources</BreadcrumbItem>
              </Breadcrumb>
            <div className='information-content'>
              <h2>Self-Learning Resources</h2>
              <p>We have put together a list of resources that you can use to expand your knowledge and skills related to academic research, citation, and referencing.</p>
            {/* <p className="fw-bold pt-2">Happy Learning</p> */}
            </div>
            <Row>
                <Col lg={4} className="border-end">
                  <div className="research-box">
                    <h5>Websites for Citing Resources</h5>
                    <ul>
                      <li>
                          <a target="_blank" href="https://www.citationmachine.net/" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.citationmachine.net/
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://www.citefast.com/" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.citefast.com/
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://www.bibme.org/apa" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.bibme.org/apa
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://www.calvin.edu/library/knightcite/" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.calvin.edu/library/knightcite/
                          </a>
                      </li>
                    </ul>
                  </div>
                </Col>
               
                <Col lg={4} className="border-end">
                  <div className="research-box">
                    <h5>Free Software</h5>
                    <ul>
                      <li>
                          <a target="_blank" href="https://www.mendeley.com/" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.mendeley.com/
                          </a>
                      </li>
                      
                    <p className="fw-bold pt-2">Installation Guidelines</p>
                      <li>
                          <a target="_blank" href="https://www.lib.ncsu.edu/citation-management/zotero" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.lib.ncsu.edu/
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://www.zotero.org/" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://www.zotero.org/
                          </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="research-box">
                    <h5>Learning Citation Styles</h5>
                    <ul>
                      <li>
                          <a href="https://owl.purdue.edu/owl/research_and_citation/resources.html" target="_blank" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://owl.purdue.edu/
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://irsc.libguides.com/APA/" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            https://irsc.libguides.com/APA/
                          </a>
                      </li>
                    </ul>
                  </div>
                </Col>
               
            </Row>
            <Row className="align-items-center pt-3">
                <Col lg={5}>
                  <div className="research-box">
                    <h5>Videos</h5>
                    {/* <p className="fw-bold pt-2">How to search HU Library Catalog</p> */}
                    <ul>
                    <li>
                          <a target="_blank" href="https://www.youtube.com/watch?v=b8JM-YIgLoI" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            How to search HU Library Catalog
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://vimeo.com/95551890" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Citation for Beginners
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://www.youtube.com/watch?v=4xDnNPQAdDw" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Cite your sources
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://libguides.library.kent.edu/tutorials" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            APA 7th Edition
                          </a>
                      </li>
                      {/* <li>
                          <a target="_blank" href="https://library.purdueglobal.edu/library/tutorials#s-lg-box-wrapper-21693061" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Purdue Global
                          </a>
                      </li> */}
                      <li>
                          <a target="_blank" href="https://library.purdueglobal.edu/library/tutorials#s-lg-box-wrapper-21693049" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Getting Started with Research
                          </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://www.lib.ncsu.edu/tutorials/evaluating-sources" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Evaluating Sources for Credibility
                          </a>
                      </li>
                    </ul>
                  </div>
                </Col>
                <Col lg={7}>
                  <div className="research-box-video">
                        <video className="shadow" width="100%" height="100%" poster="../assets/img/selflearning/Video-thumbnail.jpg" controls>
                          <source src="./assets/img/selflearning/hu-Librar-Online-Catalog.mp4" type="video/mp4"/>
                          <source src="./assets/img/selflearning/hu-Librar-Online-Catalog.mp4" type="video/ogg"/>
                          Your browser does not support the video tag.
                        </video>
                  </div>
                </Col>
            </Row>
         </Container>
    </section>
   
     
    </div>
  );
}
export default SelfLearningResources;